<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">ثبت خرید</h5>
        <div style="flex: 1"></div>
        <Back url="/admin/shop" />
      </div>
      <div class="card-body">
        <form @submit.prevent="submit">
          <b-form-group
            v-show="
              hasPermission('write_created_at_in_mini_orders') ? true : false
            "
            class="col-md-6"
            label="زمان ثبت"
          >
            <date-picker
              type="datetime"
              v-model="created_at"
              :format="'YYYY-MM-DD HH:mm'"
              :display-format="'jYYYY-jMM-jDD HH:mm'"
            />
          </b-form-group>
          <b-form-group label="انتخاب مشتری">
            <div class="d-flex col-md-6 mb-3" style="gap: 0.5rem">
              <b-form-input
                @keypress.enter.prevent="requestCustomer"
                v-model="customerMobile"
                :disabled="disabled || !!customerInfo"
                @input="requestCustomer"
                type="text"
                autofocus
              />
              <button
                @click="clearCustomer"
                v-if="customerInfo"
                class="btn btn-danger"
              >
                لغو مشتری
              </button>
            </div>
            <template v-if="customerInfo">
              <div v-if="customerInfo.customer" class="customer-info-box">
                <div
                  v-for="i in [['حضوری', 'physical']]"
                  :key="i[1]"
                  class="row g-3"
                >
                  <!-- شارژ کیف پول -->
                  <div class="col-6 col-md-4 col-lg">
                    <div class="info-card">
                      <div class="info-card-icon wallet-icon">
                        <i class="fas fa-wallet"></i>
                      </div>
                      <div class="info-card-body">
                        <span class="info-card-label">شارژ کیف پول</span>
                        <span
                          v-if="
                            customerInfo.customer &&
                              customerInfo.customer.wallet &&
                              customerInfo.customer.wallet.balance &&
                              customerInfo.customer.wallet.balance > 0
                          "
                          class="info-card-value"
                        >
                          {{ customerInfo.customer.wallet.balance | price }}
                          <small class="info-card-unit">تومان</small>
                        </span>
                        <span v-else class="info-card-value text-muted">—</span>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="
                      customerInfo.customer.customers_club_level &&
                        customerInfo.customer.customers_club_level.level
                    "
                    class="col-6 col-md-4 col-lg"
                  >
                    <div class="info-card">
                      <div class="info-card-icon level-icon">
                        <i class="fas fa-medal"></i>
                      </div>
                      <div class="info-card-body">
                        <span class="info-card-label">سطح مشتری</span>
                        <span class="info-card-value">
                          {{ customerInfo.customer.customers_club_level.level }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-4 col-lg">
                    <div class="info-card">
                      <div class="info-card-icon bon-icon">
                        <i class="fas fa-gift"></i>
                      </div>
                      <div class="info-card-body">
                        <span class="info-card-label">مقدار بن مشتری</span>
                        <span class="info-card-value">
                          {{ customerInfo.customer.customers_club_bon }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-4 col-lg">
                    <div class="info-card">
                      <div class="info-card-icon score-icon">
                        <i class="fas fa-star"></i>
                      </div>
                      <div class="info-card-body">
                        <span class="info-card-label">میزان امتیاز مشتری</span>
                        <span class="info-card-value">
                          {{ customerInfo.customer.customers_club_score }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 font-weight-bold" v-else>مشتری جدید</div>
            </template>
          </b-form-group>
          <div class="row">
            <b-form-group class="col-md-6" label="نام">
              <b-form-input type="text" v-model="firstName" />
            </b-form-group>
            <b-form-group class="col-md-6" label="نام خانوادگی">
              <b-form-input type="text" v-model="lastName" />
            </b-form-group>
          </div>
          <b-form-group class="col-12">
            <label class="" for="products">
              فروشنده <i class="text-danger">*</i></label
            >
            <div id="selectSeller">
              <button
                v-for="(seller, index) in sellers"
                :key="index"
                class="sellerBtn"
                :class="{ active: selectedSellerId == seller.id }"
                type="button"
                @click="selectedSellerFunc(seller)"
              >
                {{ seller.label }}
              </button>
            </div>
          </b-form-group>
          <b-form-group label="انتخاب محصول">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input
                autocomplete="off"
                ref="productSku"
                v-model="productSku"
                :disabled="disabled"
                @keypress.prevent.enter="requestProduct"
                type="text"
              />
              <div class="d-flex mr-3" style="gap: 0.6rem">
                <label for="refund_checkbox">مرجوعی</label>
                <b-form-checkbox
                  id="refund_checkbox"
                  type="checkbox"
                  :disabled="disabled"
                  v-model="refund"
                />
              </div>
            </div>
          </b-form-group>
          <b-form-group label="جستجوی محصول" class="mb-5">
            <ProductSearch
              ref="productSearch"
              :store="{ id: 1 }"
              :selectable="true"
              class="row mb-5"
              :show-label="false"
              @selectVariety="selectVariety"
            />
          </b-form-group>
          <div
            v-for="i in ['varieties', 'refund_varieties']"
            v-if="$data[i] != ''"
          >
            <template>
              <h4 class="table-title">
                <template v-if="i === 'varieties'">فروش</template>
                <template v-else>مرجوع</template>
              </h4>
            </template>
            <b-table
              class="mt-3 admin-order"
              :class="$data[i]"
              hover
              bordered
              responsive
              :items="$data[i]"
              :key="hasSelectedItem ? 'with-bon' : 'without-bon'"
              :fields="getFields(i)"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(image)="data" class="text-center">
                <div class="order-product-img">
                  <a :href="getImage(data.item)">
                    <img class="w-100 h-100" :src="getImage(data.item)" />
                  </a>
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <span style="width: 300px">
                  <span style="line-height: 2">{{
                    data.item.product.title
                  }}</span>
                  <span v-if="data.item.color || data.item.attributes != ''">
                    <span> | </span>
                    <span v-if="data.item.color">
                      رنگ : {{ data.item.color.name }}
                      {{ data.item.attributes != "" ? " | " : "" }}
                    </span>
                    <span v-if="data.item.attributes != ''">
                      <span
                        v-for="(attr, index) in data.item.attributes"
                        :key="index"
                      >
                        {{ attr.label + ": " + attr.pivot.value }}
                        {{
                          index != data.item.attributes.length - 1 ? " | " : ""
                        }}
                      </span>
                    </span>
                  </span>
                </span>
              </template>
              <template v-slot:cell(quantity)="data">
                <button
                  type="button"
                  class="border border-radius7 px-1 bg-none"
                  @click="decrement(data.item)"
                  :disabled="data.item.quantity == 1 || disabled ? true : false"
                >
                  <DashSvg />
                </button>
                <span class="px-2">{{ data.item.quantity }}</span>
                <button
                  type="button"
                  class="border border-radius7 px-1 bg-none"
                  @click="increment(data.item)"
                  :disabled="disabled"
                >
                  <PlusSvg />
                </button>
              </template>
              <template v-slot:cell(amount)="data">
                <b-form-input
                  v-if="i !== 'varieties'"
                  style="width: 80px"
                  class="m-auto"
                  :value="data.item.price | priceinput"
                  @input="
                    (value) => {
                      data.item.price =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                >
                </b-form-input>
                <span v-else>
                  {{ data.item.price | price }}
                </span>
              </template>
              <template v-slot:cell(discount_amount)="data">
                <div class="d-flex flex-column align-items-center">
                  <b-form-input
                    style="width: 110px"
                    class="m-auto"
                    type="text"
                    inputmode="numeric"
                    placeholder="0"
                    :disabled="
                      i !== 'varieties' && !!data.item.selectedOrderItem
                    "
                    :value="
                      data.item.selectedOrderItem
                        ? getTotalDiscount(data.item)
                        : data.item.cashier_discount
                        ? $options.filters.priceinput(
                            data.item.cashier_discount,
                          )
                        : ''
                    "
                    @input="(value) => onDiscountInput(value, data.item)"
                  />

                  <small v-if="i === 'varieties'" class="text-muted mt-1">
                    تخفیف محصول:
                    {{ getProductDiscount(data.item) | price }}
                    تومان
                  </small>

                  <small
                    v-if="getClubDiscountPrice(data.item) > 0"
                    class="text-success"
                  >
                    تخفیف باشگاه:
                    {{ getClubDiscountPrice(data.item) | price }}
                    تومان
                  </small>

                  <small>
                    مجموع تخفیف:
                    {{ getTotalDiscount(data.item) | price }}
                    تومان
                  </small>
                </div>
              </template>
              <template v-slot:cell(flash)="data">
                {{
                  data.item.product && data.item.product.active_flash != ""
                    ? data.item.product.active_flash[0].title
                    : "ندارد"
                }}
              </template>
              <template v-slot:cell(total_price)="data">
                <span v-if="data.item.final_price.amount != 0">
                  <!-- <span v-if="i !== 'varieties'">{{
                    (data.item.price * data.item.quantity -
                      data.item.final_price.discount_price *
                        data.item.quantity)
                      | price 
                  }}</span> -->
                  <!-- <span v-if="i !== 'varieties'">
                    {{
                      (data.item.price * data.item.quantity -
                        getTotalDiscount(data.item) * data.item.quantity)
                        | price
                    }}
                  </span> -->
                  <span v-if="i !== 'varieties'">
                    {{
                      (getRefundUnitAmount(data.item) * data.item.quantity)
                        | price
                    }}
                  </span>
                  <!-- <span v-else>{{
                    editDiscount[data.item.id]
                      ? data.item.final_price.amount * data.item.quantity -
                        data.item.final_price.discount_price *
                          data.item.quantity
                      : (data.item.final_price.amount * data.item.quantity)
                        | price
                  }}</span> -->
                  <span v-else>
                    {{
                      (data.item.price * data.item.quantity -
                        getTotalDiscount(data.item) * data.item.quantity)
                        | price
                    }}
                  </span>
                </span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(seller_id)="data">
                <b-button @click="sellerModalHandler(data.item.id)">
                  <span>
                    {{
                      seller_ids[data.item.id] && seller_ids[data.item.id].label
                        ? seller_ids[data.item.id].label
                        : "انتخاب نشده"
                    }}
                  </span>
                  <i class="fa fa-angle-down"></i>
                </b-button>
              </template>
              <template v-slot:cell(factor_id)="data">
                <div class="d-flex flex-column align-items-center">
                  <b-form-input
                    v-model="data.item.orderNumber"
                    type="text"
                    inputmode="numeric"
                    placeholder="شماره فاکتور"
                    class="w-100 mb-1"
                    :disabled="!customerInfo || !!data.item.orderLoading"
                    @keypress.enter.prevent="fetchOrder(data.item)"
                    @blur="fetchOrder(data.item)"
                  />

                  <small v-if="data.item.orderLoading" class="text-muted mb-2">
                    در حال دریافت فاکتور...
                  </small>
                  <small
                    v-else-if="data.item.orderError"
                    class="text-danger mb-2"
                  >
                    {{ data.item.orderError }}
                  </small>
                  <small
                    v-else-if="data.item.selectedOrder"
                    class="text-success mb-2"
                  >
                    قیمت فاکتور:
                    {{ data.item.selectedOrder.pos_amount | price }} تومان
                  </small>
                  <b-form-select
                    v-if="
                      data.item.selectedOrder &&
                        data.item.selectedOrder.mini_order_items.length > 0
                    "
                    :value="data.item.selectedOrderItem"
                    @change="
                      (orderItem) => onOrderItemSelect(data.item, orderItem)
                    "
                    :options="[
                      {
                        text: 'آیتم را انتخاب کنید',
                        value: null,
                        disabled: true,
                      },
                      ...data.item.selectedOrder.mini_order_items.map(
                        (item) => ({
                          text: item.title,
                          value: item,
                        }),
                      ),
                    ]"
                    class="w-100"
                  />
                  <!-- <b-form-select
                    v-if="
                      data.item.selectedOrder &&
                        data.item.selectedOrder.mini_order_items.length > 0
                    "
                    v-model="data.item.selectedOrderItem"
                    :options="[
                      {
                        text: 'آیتم را انتخاب کنید',
                        value: null,
                        disabled: true,
                      },
                      ...data.item.selectedOrder.mini_order_items.map(
                        (item) => ({
                          text: item.title,
                          value: item,
                        }),
                      ),
                    ]"
                    class="w-100"
                  /> -->
                </div>
              </template>
              <template v-slot:cell(gift_bon)="data">
                <span v-if="data.item.selectedOrderItem">
                  {{
                    data.item.selectedOrderItem.gift_bon * data.item.quantity
                  }}
                </span>
              </template>
              <template v-slot:cell(delete)="data">
                <a
                  class="action-btns1 pt-1 px-2"
                  @click="deleteItem(data.item, i)"
                >
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </template>
            </b-table>
          </div>
          <template v-if="varieties != '' || refund_varieties != ''">
            <div
              class="mt-5 col-md-5 mx-auto card justify-content-center little py-5 d-flex"
            >
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> مجموع قیمت کالا ها : </span>
                <span class="px-3 py-2"> {{ total | price }} تومان </span>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مجموع قیمت مرجوعی ها :
                </span>
                <span class="px-3 py-2">
                  <!-- {{
                    refund_varieties.reduce(
                      (total, variety) =>
                        total + variety.price * variety.quantity,
                      0,
                    ) | price
                  }} -->
                  {{ totalRefundAmount | price }}
                  تومان
                </span>
              </div>
              <!-- <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> جمع تخفیفات : </span>
                <span class="px-3 py-2">
                  {{
                    (varieties.reduce(
                      (total, variety) =>
                        total +
                        variety.final_price.discount_price * variety.quantity,
                      0,
                    ) +
                      refund_varieties.reduce(
                        (total, variety) =>
                          total +
                          variety.final_price.discount_price * variety.quantity,
                        0,
                      ))
                      | price
                  }}
                  تومان
                </span>
              </div> -->
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">جمع تخفیفات:</span>
                <span class="px-3 py-2">
                  {{ totalDiscount | price }} تومان
                </span>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> فاکتور باز : </span>
                <div class="px-3 py-2">
                  <input type="checkbox" v-model="isOpen" />
                </div>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ کارت به کارت (تومان):
                </span>
                <b-form-input
                  style="width: 130px"
                  :value="cardByCard_amount | priceinput"
                  @input="
                    (value) => {
                      cardByCard_amount =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ پرداخت نقدی (تومان):
                </span>
                <b-form-input
                  style="width: 130px"
                  :value="cash_amount | priceinput"
                  @input="
                    (value) => {
                      cash_amount =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                />
              </div>

              <div
                v-if="
                  customerInfo &&
                    customerInfo.bon_value &&
                    customerInfo.customer.customers_club_bon > 0
                "
                class="d-md-flex justify-content-between  py-2"
              >
                <span class="px-3 font-bold">
                  تعداد بن مورد استفاده:
                </span>
                <div class="">
                  <b-form-input
                    style="width: 130px"
                    type="number"
                    min="0"
                    :max="maxBonCount"
                    :value="bonCount"
                    @input="onBonCountInput"
                  />
                  <small class="text-muted d-block">
                    موجودی: {{ customerInfo.customer.customers_club_bon }} بن
                  </small>
                  <small v-if="refundedGiftBon > 0" class="text-danger d-block">
                    بن (غیرقابل مصرف): {{ refundedGiftBon }} بن
                  </small>
                  <small class="text-muted d-block">
                    ارزش :
                    {{ (customerInfo.bon_value.value * bonCount) | price }}
                    تومان
                  </small>
                </div>
              </div>
              <div
                v-if="
                  customerInfo &&
                    customerInfo.customer &&
                    customerInfo.customer.wallet &&
                    customerInfo.customer.wallet.balance &&
                    customerInfo.customer.wallet.balance > 0
                "
                class="d-md-flex justify-content-between"
              >
                <span class="px-3 py-2 font-bold">
                  میزان کسر از کیف پول (تومان):
                </span>
                <b-form-input
                  style="width: 130px"
                  :value="walletB | priceinput"
                  @input="
                    (val) => {
                      let num = +val.replace(/\D/g, '');
                      let max =
                        customerInfo && customerInfo.customer
                          ? customerInfo.customer.wallet.balance
                          : 0 || 0;
                      walletB = num > max ? max : num;
                    }
                  "
                />
              </div>
              <!-- <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> پرداخت از پوز (ریال): </span>
                <span
                  class="px-3 py-2"
                  :class="{
                    'text-success': totalPrice >= 0,
                    'text-danger': totalPrice < 0,
                  }"
                >
                  {{ (totalPrice * 10) | price }} ریال
                </span>
              </div> -->
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> پرداخت از پوز (ریال): </span>
                <span class="px-3 py-2 text-success"
                  >{{ (totalPrice * 10) | price }} ریال</span
                >
              </div>
              <div
                v-if="refundToCustomer > 0"
                class="d-md-flex justify-content-between"
              >
                <span class="px-3 py-2 font-bold">مبلغ بازگشتی به مشتری:</span>
                <span class="px-3 py-2 text-danger"
                  >{{ (refundToCustomer * 10) | price }} ریال</span
                >
              </div>
            </div>
            <div class="row mt-4">
              <b-form-group
                class="col-md-6"
                label="یادداشت"
                :label-for="'description'"
              >
                <b-form-textarea
                  id="description"
                  v-model="description"
                  placeholder="یادداشت"
                  :required="isDiscountFilled"
                />
              </b-form-group>
            </div>
            <div class="mt-4 w-100 d-flex justify-content-center">
              <button
                type="button"
                @click="submitPos"
                :class="{ reqDiasableStyle: disablePos }"
                class="btn btn-success ml-2"
              >
                ارسال به پز
              </button>
              <button
                type="submit "
                :class="{ reqDiasableStyle: !reqDiasableStyle }"
                class="btn btn-success"
              >
                ثبت سفارش
              </button>
            </div>
          </template>
        </form>
      </div>
      <div id="selectSellerModal" @click="closeModal" v-if="showModal">
        <div id="selectSellerModalContainer">
          <div class="card">
            <div class="card-header border-0">
              <h5 class="card-title font-bold py-3">انتخاب فروشنده</h5>
              <div style="flex: 1"></div>
              <b-button variant="danger" @click="closeModal('close')"
                >X</b-button
              >
            </div>
            <div class="card-body">
              <div id="selectSeller">
                <button
                  v-for="(seller, index) in sellers"
                  :key="index"
                  class="sellerBtn"
                  type="button"
                  @click="selectedSellerForVariety(seller)"
                >
                  {{ seller.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {
  BFormGroup,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
  BFormTextarea,
  BFormSelect,
} from "bootstrap-vue";
import PlusSvg from "@@/core/components/svgs/PlusSvg";
import DashSvg from "@@/core/components/svgs/DashSvg";
import Back from "@@/core/components/shared/Back/Back";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "ShopCreate",
  components: {
    DashSvg,
    PlusSvg,
    BFormGroup,
    BFormInput,
    BTable,
    BFormCheckbox,
    BFormTextarea,
    BFormSelect,
    BButton,
    Back,
    ProductSearch,
  },
  data() {
    return {
      disablePos: false, // وقتی درخواست «ارسال به پز» در جریان است true می‌شود (جلوگیری از کلیک دوباره)
      disabled: false, // قفل کردن اینپوت‌ها و دکمه‌ها هنگام درخواست‌های API
      refund: false, // چک‌باکس «مرجوعی»؛ اگر true باشد محصول اسکن‌شده به لیست مرجوعی می‌رود
      selectedSeller: null, // فروشنده‌ای که بالای صفحه انتخاب شده (آبجکت کامل)
      selectedSellerId: null, // id همان فروشنده (برای هایلایت دکمه)
      seller_ids: {}, // مپ { varietyId: {label, id} } فروشنده هر ردیف
      // ⚠️ این آبجکت ریکتیو نیست؛ چون کلید جدید با = اضافه می‌شود. بهتر است از this.$set استفاده شود
      showModal: false, // نمایش مودال انتخاب فروشنده برای یک ردیف
      created_at: null, // زمان ثبت دستی (فقط با پرمیشن مربوطه)
      editDiscount: {}, // ردیف‌هایی که تخفیفشان دستی ویرایش شده { varietyId: 1 }
      discountAmount: 0, // تخفیف کلی فاکتور (فعلاً در UI ورودی ندارد)
      bonValue: 0, // ارزش ریالی/تومانی بن‌های مصرفی (bonCount × ارزش هر بن)
      bonCount: 0, // تعداد بن مصرفی
      cardByCard_amount: null, // مبلغ پرداخت کارت‌به‌کارت
      cash_amount: null, // مبلغ پرداخت نقدی
      description: null, // یادداشت فاکتور
      sendCoupenStatus: false, // ارسال کد تخفیف (در حال حاضر عملاً استفاده نمی‌شود)
      sellers: [], // لیست فروشنده‌های فعال
      admin: null, // ادمین لاگین‌شده (برای creatorable_id)
      isOpen: 0, // فاکتور باز
      selectedVarietyId: null, // ردیفی که مودال فروشنده برایش باز شده
      productSku: "", // مقدار اینپوت بارکد
      reqDiasableStyle: true, // ⚠️ نام گمراه‌کننده: true یعنی دکمه «ثبت سفارش» فعال است
      customerMobile: "", // شماره موبایل مشتری
      varieties: [], // آیتم‌های فروش
      refund_varieties: [], // آیتم‌های مرجوعی
      firstName: "",
      lastName: "",
      customerInfo: null, // اطلاعات مشتری از API (کیف پول، باشگاه، بن، ...)
      flag: true, // استفاده نمی‌شود
      coupenPrice: null, // مبلغ تخفیف کد کوپن تأییدشده
      walletB: null, // مبلغی که قرار است از کیف پول کسر شود
      coupen: null, // کد کوپن
      disableCoupen: false,
      // orderItems: [], // فاکتورهای قبلی مشتری برای انتخاب در مرجوعی
      hasSelectedItem: false, // آیا برای مرجوعی آیتم فاکتور مرجع انتخاب شده (ستون gift_bon را نشان می‌دهد)
    };
  },
  computed: {
    // اگر تخفیف کلی داریم یا مبلغ پرداختی ≤ 0 است، یادداشت اجباری می‌شود
    isDiscountFilled() {
      if (this.discountAmount > 0) {
        return true;
      } else if (this.totalPrice <= 0) {
        return true;
      } else {
        return false;
      }
    },
    // تعداد بنی که مشتری از آیتم‌های مرجوعی (فاکتور مرجع) دریافت کرده بوده
    // این بن‌ها با مرجوعی برگردانده می‌شوند، پس قابل مصرف نیستند
    // (همان فرمول ستون «تعداد بن دریافتی» در جدول: gift_bon × تعداد)
    refundedGiftBon() {
      return this.refund_varieties.reduce((total, item) => {
        if (!item.selectedOrderItem) return total;
        return (
          total +
          (Number(item.selectedOrderItem.gift_bon) || 0) *
            (Number(item.quantity) || 0)
        );
      }, 0);
    },

    // بن قابل مصرف = موجودی مشتری − بن‌های دریافتی از آیتم‌های مرجوعی
    spendableBonCount() {
      const customerBon =
        Number(this.customerInfo?.customer?.customers_club_bon) || 0;
      return Math.max(0, customerBon - this.refundedGiftBon);
    },
    // حداکثر تعداد بنی که مشتری می‌تواند مصرف کند
    // = min(بن‌های مشتری ، مبلغ قابل پرداخت ÷ ارزش هر بن)
    maxBonCount() {
      const bonValue = Number(this.customerInfo?.bon_value?.value) || 0;

      if (bonValue <= 0) return 0;

      // مبلغ خالص هر آیتم فروش = (قیمت - کل تخفیف) × تعداد
      const getNetAmount = (item) =>
        Math.max(0, Number(item.price || 0) - this.getTotalDiscount(item)) *
        Number(item.quantity || 0);

      const saleAmount = this.varieties.reduce(
        (total, item) => total + getNetAmount(item),
        0,
      );

      const refundAmount = this.refund_varieties.reduce(
        (t, item) =>
          t + this.getRefundUnitAmount(item) * Number(item.quantity || 0),
        0,
      );
      const walletBalance =
        Number(this.customerInfo?.customer?.wallet?.balance) || 0;

      // مبلغ کیف پول نباید از موجودی بیشتر حساب شود
      const walletAmount = Math.min(
        Math.max(0, Number(this.walletB) || 0),
        walletBalance,
      );

      // مبلغی که هنوز باقی مانده (بعد از کسر مرجوعی، تخفیف، کوپن، کارت، نقد، کیف پول)
      const payableAmount = Math.max(
        0,
        saleAmount -
          refundAmount -
          (Number(this.discountAmount) || 0) -
          (Number(this.coupenPrice) || 0) -
          (Number(this.cardByCard_amount) || 0) -
          (Number(this.cash_amount) || 0) -
          walletAmount,
      );

      // const customerBonCount =
      //   Number(this.customerInfo?.customer?.customers_club_bon) || 0;
      const customerBonCount = this.spendableBonCount;
      return Math.min(customerBonCount, Math.floor(payableAmount / bonValue));
    },

    // جمع تخفیف‌ها (تخفیف محصول + تخفیف باشگاه) × تعداد
    // برای مرجوعی‌هایی که فاکتور مرجع دارند، تخفیف حساب نمی‌شود (مبلغ از فاکتور قبلی می‌آید)
    totalDiscount() {
      const calculateDiscount = (variety) => {
        const productDiscount =
          Number(variety.final_price?.discount_price) || 0;
        const clubDiscount = this.getClubDiscountPrice(variety);
        const cashierDiscount = Number(variety.cashier_discount) || 0;
        return (
          (productDiscount + clubDiscount + cashierDiscount) * variety.quantity
        );
      };
      return (
        this.varieties.reduce((t, v) => t + calculateDiscount(v), 0) +
        this.refund_varieties.reduce(
          (t, v) => t + (v.selectedOrderItem ? 0 : calculateDiscount(v)),
          0,
        )
      );
    },

    // جمع قیمت کالاهای فروش (بدون تخفیف)
    total() {
      const totalVarieties = this.varieties.reduce(
        (a, b) => a + b.price * b.quantity,
        0,
      );

      return totalVarieties;
    },

    // 🔑 محاسبهٔ اصلی «مبلغ نهایی قابل پرداخت از پوز»
    // ترتیب: فروش - مرجوعی - تخفیف‌ها - کوپن/کارت/نقد/بن - کیف پول
    // می‌تواند منفی شود (یعنی باید به مشتری پول برگردد)
    netTotal() {
      const totalRefundAmount = this.refund_varieties.reduce(
        (sum, item) => sum + this.getRefundUnitAmount(item) * item.quantity,
        0,
      );

      let totalAmount = this.total - totalRefundAmount;
      totalAmount -= this.varieties.reduce(
        (total, item) => total + this.getTotalDiscount(item) * item.quantity,
        0,
      );
      if (this.discountAmount > 0) totalAmount -= this.discountAmount;
      if (this.cardByCard_amount > 0) totalAmount -= this.cardByCard_amount;
      if (this.cash_amount > 0) totalAmount -= this.cash_amount;
      if (this.bonValue > 0) totalAmount -= this.bonValue;

      // کیف پول: حداکثر به اندازهٔ موجودی
      let effectiveWallet = Number(this.walletB) || 0;
      const walletBalance = this.customerInfo?.customer?.wallet?.balance || 0;
      if (effectiveWallet > walletBalance) {
        effectiveWallet = walletBalance;
      }

      // کیف پول فقط وقتی کسر می‌شود که هنوز مبلغ مثبتی باقی مانده باشد
      // ⚠️ نکتهٔ مهم: اگر کارت‌به‌کارت/نقد همهٔ مبلغ را پوشش داده باشد، این شرط رد می‌شود
      // ولی walletB همچنان مقدار دارد و در submit به سرور فرستاده می‌شود (توضیح در پاسخ)
      if (totalAmount > 0) {
        if (effectiveWallet >= totalAmount) {
          totalAmount = 0;
        } else {
          totalAmount -= effectiveWallet;
        }
      }

      return totalAmount;
    },

    // جمع مبلغ مرجوعی‌ها (برای نمایش در خلاصه)
    totalRefundAmount() {
      return this.refund_varieties.reduce(
        (sum, item) =>
          sum + this.getRefundUnitAmount(item) * Number(item.quantity || 0),
        0,
      );
    },

    // مبلغ پرداخت از پوز؛ هیچ‌وقت منفی نمی‌شود
    totalPrice() {
      return Math.max(0, this.netTotal);
    },

    // مبلغی که باید به مشتری برگردد (وقتی netTotal منفی است)
    refundToCustomer() {
      return Math.max(0, -this.netTotal);
    },
  },
  mounted() {
    this.listenForKeyPress();
  },
  methods: {
    // ستون‌های جدول؛ برای مرجوعی دو ستون اضافه (فاکتور فروش، بن مصرف‌شده) اضافه می‌شود
    getFields(type) {
      const baseFields = [
        { key: "index", label: "ردیف" },
        { key: "barcode", label: "بارکد" },
        { key: "image", label: "تصویر" },
        { key: "title", label: "عنوان" },
        { key: "amount", label: "قیمت واحد (تومان)" },
        { key: "quantity", label: "تعداد" },
        { key: "discount_amount", label: "تخفیف واحد (تومان)" },
        { key: "seller_id", label: "فروشنده" },
        { key: "flash", label: "کمپین" },
        { key: "total_price", label: "قیمت نهایی (تومان)" },
        { key: "delete", label: "حذف" },
      ];
      if (type === "refund_varieties") {
        // قبل از ستون «قیمت نهایی» درج می‌شود
        baseFields.splice(baseFields.length - 2, 0, {
          key: "factor_id",
          label: "فاکتور فروش",
        });
        if (this.hasSelectedItem) {
          baseFields.splice(baseFields.length - 2, 0, {
            key: "gift_bon",
            label: "تعداد  بن دریافتی",
          });
        }
      }
      return baseFields;
    },

    // مبلغ برگشتی «هر واحد» مرجوعی:
    // - اگر فاکتور مرجع انتخاب شده: مبلغ همان فاکتور منهای ارزش بن‌های مصرف‌شده
    // - وگرنه: قیمت منهای تخفیف‌ها
    getRefundUnitAmount(item) {
      return Math.max(
        0,
        (Number(item.price) || 0) - this.getTotalDiscount(item),
      );
    },

    // ارزش پولی بن‌های مصرف‌شده در یک آیتم فاکتور (تعداد بن × ارزش هر بن)
    getBonAmount(sel) {
      const unit = Number(this.customerInfo?.bon_value?.value) || 0;
      return (Number(sel.gift_bon) || 0) * unit;
    },
    // سهم هر آیتم از بن مصرف‌شده در فاکتور مرجع
    // = bon_value فاکتور ÷ تعداد آیتم‌های فاکتور (فقط آیتم‌های sell که در watch فیلتر شده‌اند)
    getSpendBonPerItem(item) {
      const order = item.selectedOrder;
      if (!order) return 0;

      const count = order.mini_order_items?.length || 0;
      if (!count) return 0;

      return Math.ceil((Number(order.bon_value) || 0) / count);
    },
    // تخفیف باشگاه مشتری برای هر واحد = قیمت × درصد سطح مشتری در فروش
    //در مرجع مبلغ است
    getClubDiscountPrice(item) {
      // آیتم‌های مرجوعی تخفیف باشگاه ندارند
      if (this.refund_varieties.includes(item)) return 0;

      if (item.selectedOrderItem) {
        return Number(item.selectedOrderItem.club_discount) || 0;
      }

      const percentage =
        Number(
          this.customerInfo?.customer?.customers_club_level
            ?.coupon_discount_percentage,
        ) || 0;

      const price = Number(item.price) || 0;

      return Math.round((price * percentage) / 100);
    },
    onOrderSelect(item) {
      item.selectedOrderItem = null;
      const order = item.selectedOrder;
      if (!order || !order.mini_order_items || order._processed) return;

      order.mini_order_items = order.mini_order_items
        .filter((i) => i.type === "sell")
        .map((i) => {
          const qty = Number(i.quantity) || 1;
          const baseBon = Number(i.original_gift_bon ?? i.gift_bon ?? 0);
          const baseScore = Number(i.original_gift_score ?? i.gift_score ?? 0);
          return {
            ...i,
            gift_bon: qty > 1 ? Math.ceil(baseBon / qty) : baseBon,
            original_gift_bon: baseBon,
            gift_score: qty > 1 ? Math.ceil(baseScore / qty) : baseScore,
            original_gift_score: baseScore,
          };
        });
      order._processed = true;
    },
    // مجموع تخفیف هر واحد = تخفیف محصول + تخفیف باشگاه
    getTotalDiscount(item) {
      const cashier = item.selectedOrderItem
        ? 0
        : Number(item.cashier_discount) || 0;
      return (
        this.getProductDiscount(item) +
        this.getClubDiscountPrice(item) +
        cashier
      );
    },
    // تخفیف محصول هر واحد برای نمایش در جدول
    // مرجوعی با فاکتور مرجع: discount_amount همان آیتم فاکتور
    // بقیه حالت‌ها: تخفیف فعلی محصول
    getProductDiscount(item) {
      if (item.selectedOrderItem) {
        return Number(item.selectedOrderItem.discount_amount) || 0;
      }
      return Number(item.final_price?.discount_price) || 0;
    },
    // وقتی کاربر تعداد بن را عوض می‌کند: عدد را بین 0 و maxBonCount محدود می‌کند
    onBonCountInput(value) {
      const max = this.maxBonCount;
      let count = value !== "" ? Math.floor(Number(value)) : 0;

      if (!Number.isFinite(count) || count < 0) count = 0;
      if (count > max) count = max;

      this.bonCount = count;
      this.bonValue =
        count * (Number(this.customerInfo?.bon_value?.value) || 0);
      // ⚠️ اگر کاربر بعد از وارد کردن بن، مبلغ آیتم‌ها را عوض کند، bonCount دوباره کلمپ نمی‌شود
      // (فقط در submit یک‌بار کلمپ می‌شود)
    },

    // ارسال مبلغ به دستگاه پوز
    async submitPos() {
      this.disablePos = true;
      let fd = new FormData();
      this.varieties.forEach((item, index) => {
        fd.append(`variety_ids[${index}]`, item.id);
      });
      fd.append(`pos_amount`, this.totalPrice);
      try {
        const response = await this.$axios.post(
          "admin/mini_orders/send-to-pos",
          fd,
        );
        this.$root.notify(response.data.message, "success");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disablePos = false;
      }
    },

    // گرفتن اطلاعات ادمین فعلی
    async getAdmin() {
      const response = await this.$axios.get("admin/home");
      this.admin = response.data.data.admin;
    },

    // گرفتن لیست فروشنده‌های فعال و ساخت label برای دکمه‌ها
    async getSellers() {
      const response = await this.$axios.get("admin/sellers?all=1&active=1");
      this.sellers = response.data.data.sellers.map((s) => {
        s.label = `${s.full_name}`;
        return s;
      });
    },

    // اگر کوپن قبلاً محاسبه شده و چیزی تغییر کند، کوپن باطل می‌شود و هشدار می‌دهد
    checkCoupon() {
      if (this.coupenPrice) {
        this.coupenPrice = null;
        this.$root.notify(
          "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
          "warning",
        );
      }
    },

    // ویرایش دستی تخفیف یک ردیف؛ بین 0 و قیمت واحد محدود می‌شود
    onDiscountInput(value, item) {
      const price = Number(item.price) || 0;
      // سقف: قیمت منهای تخفیف محصول و تخفیف باشگاه
      const max = Math.max(
        0,
        price - this.getProductDiscount(item) - this.getClubDiscountPrice(item),
      );

      // فقط رقم‌ها (کاماها و کاراکترهای غیرعددی حذف می‌شوند)
      let discount = Number(String(value).replace(/\D/g, "")) || 0;
      if (discount > max) discount = max;

      this.$set(item, "cashier_discount", discount);
      this.$set(this.editDiscount, item.id, 1);
    },
    clearCoupon() {
      this.coupenPrice = null;
      this.coupen = "";
    },

    // انتخاب فروشنده برای یک ردیف از مودال
    selectedSellerForVariety(seller) {
      this.seller_ids[this.selectedVarietyId] = {
        label: seller.label,
        id: seller.id,
      };
      // ⚠️ چون seller_ids ریکتیو نیست ممکن است برچسب دکمه بلافاصله به‌روز نشود
      // پیشنهاد: this.$set(this.seller_ids, this.selectedVarietyId, {...})
      this.closeModal("close");
    },

    // رویداد انتخاب محصول از کامپوننت جستجو
    selectVariety(variety) {
      this.addVariety(variety);
    },

    // تأیید کد تخفیف از سرور
    async sendCoupen() {
      this.disableCoupen = true;
      const varieties = this.varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      const refund_varieties = this.refund_varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      try {
        let fd = new FormData();
        fd.append("code", this.coupen);
        let reqBody = {
          mobile: this.customerMobile,
          discount_amount: this.discountAmount,
          first_name: this.firstName,
          last_name: this.lastName,
          description: this.description,
          // ⚠️ this.from_wallet_amount تعریف نشده و همیشه undefined است
          from_wallet_amount: this.from_wallet_amount,
          varieties,
          refund_varieties,
        };
        if (this.coupen) {
          reqBody.coupon_code = this.coupen;
        }
        const response = await this.$axios.post("admin/coupon/verify", reqBody);

        this.coupenPrice = response.data.data.discount.discount;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disableCoupen = false;
      }
    },

    listenForKeyPress() {
      document.removeEventListener("keyup", this.onKeyPress);
      document.addEventListener("keyup", this.onKeyPress);
    },
    // ⚠️ خالی است. اگر استفاده‌ای ندارد حذف شود. ضمناً در beforeDestroy لیسنر برداشته نمی‌شود
    onKeyPress(e) {},

    // بستن مودال: یا با دکمه X ("close") یا کلیک روی پس‌زمینه
    closeModal(e) {
      if (e == "close" || e.target.id == "selectSellerModal") {
        this.showModal = false;
      }
    },

    // باز کردن مودال فروشنده برای یک ردیف
    sellerModalHandler(id) {
      this.selectedVarietyId = id;
      this.showModal = true;
    },

    // جستجوی محصول با بارکد (SKU) و افزودن به لیست
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            sku: this.productSku,
            refund: this.refund,
          },
        });
        const variety = response.data.data.variety;
        this.addVariety(variety);
        this.productSku = "";
        if (this.coupenPrice) {
          this.coupenPrice = null;
          this.$root.notify(
            "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
            "warning",
          );
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        // فوکوس برگردد روی اینپوت بارکد برای اسکن بعدی
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    addVariety(variety) {
      const mode = this.refund ? "refund_varieties" : "varieties";
      const alreadyAdded = this[mode].find((v) => v.id == variety.id);

      if (alreadyAdded) {
        alreadyAdded.quantity++;
        this.$root.notify(
          "به تعداد محصول اضافه شد: " + alreadyAdded.quantity,
          "success",
        );
        return;
      }

      // موجودی انبار را نگه می‌داریم (اگر جایی لازم شد) و quantity را برای سفارش 1 می‌کنیم
      const item = {
        ...variety,
        stock_quantity: variety.quantity,
        quantity: 1,
        cashier_discount: 0,
        orderNumber: "",
        orderLoading: false,
        orderError: "",
        selectedOrder: null,
        selectedOrderItem: null,
      };

      this[mode].push(item);

      if (mode === "varieties" && this.customerInfo?.customer?.wallet) {
        this.walletB = this.customerInfo.customer.wallet.balance || 0;
      }

      // if (
      //   mode === "refund_varieties" &&
      //   this.refund_varieties.length === 1 &&
      //   this.customerInfo &&
      //   this.customerInfo.customer
      // ) {
      //   this.$axios
      //     .get("admin/mini_orders-refund-search", {
      //       params: { mobile: this.customerMobile },
      //     })
      //     .then((res) => {
      //       this.orderItems = res.data.data.mini_orders;
      //     })
      //     .catch((e) => this.$root.notify(e));
      // }

      this.$set(
        this.seller_ids,
        item.id,
        this.selectedSeller
          ? { label: this.selectedSeller.label, id: this.selectedSeller.id }
          : {},
      );
    },
    // گرفتن فاکتور با شماره از سرور
    async fetchOrder(item) {
      const number = String(item.orderNumber || "").replace(/\D/g, "");
      item.orderNumber = number;

      if (item.selectedOrder && String(item.selectedOrder.id) === number)
        return;

      item.selectedOrder = null;
      item.selectedOrderItem = null;
      item.orderError = "";

      if (!number) return;

      item.orderLoading = true;
      try {
        const response = await this.$axios.get(`admin/mini_orders/${number}`);
        const order = response.data.data.mini_order;

        if (!order) {
          item.orderError = "فاکتوری با این شماره پیدا نشد";
          return;
        }
        if (order.type !== "sell" && order.type !== "both") {
          item.orderError =
            "این فاکتور مرجوعی است؛ شماره فاکتور فروش را وارد کنید";
          return;
        }
        // if (
        //   order.customer?.mobile &&
        //   order.customer.mobile !== this.customerMobile
        // ) {
        //   item.orderError = "این فاکتور متعلق به این مشتری نیست";
        //   return;
        // }
        // پردازش آیتم‌ها قبل از ست کردن (فقط sell، بن/امتیاز هر واحد)
        const sellItems = (order.mini_order_items || [])
          .filter((i) => i.type === "sell")
          .map((i) => {
            const qty = Number(i.quantity) || 1;
            const baseBon = Number(i.gift_bon) || 0;
            const baseScore = Number(i.gift_score) || 0;
            return {
              ...i,
              gift_bon: qty > 1 ? Math.ceil(baseBon / qty) : baseBon,
              original_gift_bon: baseBon,
              gift_score: qty > 1 ? Math.ceil(baseScore / qty) : baseScore,
              original_gift_score: baseScore,
            };
          });

        if (!sellItems.length) {
          item.orderError = "این فاکتور آیتم فروش ندارد";
          return;
        }

        item.selectedOrder = { ...order, mini_order_items: sellItems };
      } catch (e) {
        item.orderError = "فاکتوری با این شماره پیدا نشد";
      } finally {
        item.orderLoading = false;
      }
    },
    // آیدی تنوع یک آیتم فاکتور فروش؛ اگر هیچ‌کدام از فیلدها وجود نداشت null برمی‌گرداند
    getOrderItemVarietyId(orderItem) {
      const id =
        orderItem.variety_id ??
        orderItem.product_variety_id ??
        orderItem.variety?.id ??
        null;
      return id !== null && id !== undefined ? String(id) : null;
    },

    // وقتی صندوق‌دار آیتمی از فاکتور فروش را برای مرجوعی انتخاب می‌کند
    onOrderItemSelect(item, orderItem) {
      if (!orderItem) {
        item.selectedOrderItem = null;
        return;
      }

      const orderItemVarietyId = this.getOrderItemVarietyId(orderItem);

      // اگر مطابقت ندارد: هشدار بده و انتخاب را رد کن
      if (
        orderItemVarietyId !== null &&
        orderItemVarietyId !== String(item.id)
      ) {
        this.$root.notify(
          "آیتم انتخاب‌شده با محصول مرجوعی مطابقت ندارد. لطفاً آیتم یا فاکتور صحیح را انتخاب کنید.",
          "warning",
        );
        // انتخاب قبلی حفظ می‌شود (null یا آیتم درست قبلی)
        this.$forceUpdate();
        return;
      }

      item.selectedOrderItem = orderItem;
    },
    // ⚠️ متدهای زیر (calculatedPrice, formattedPriceInput, updatePrice) در template استفاده نمی‌شوند
    calculatedPrice(amount, discount) {
      return amount + discount;
    },
    formattedPriceInput(amount, discount) {
      const price = discount ? this.calculatedPrice(amount, discount) : amount;
      return price ? price.toLocaleString("fa-IR") : "";
    },
    updatePrice(data, event) {
      const value = event.target.value;
      const cleanedValue =
        value !== "" ? +value.replace(/\D/g, "").replace(/,/g, "") : "";
      this.$emit("update-price", { item: data.item, amount: cleanedValue });
    },

    // انتخاب فروشنده بالای صفحه (برای محصولات بعدی)
    selectedSellerFunc(seller) {
      this.selectedSellerId = seller.id;
      this.selectedSeller = seller;
    },

    // عکس تنوع؛ اگر نبود عکس محصول؛ اگر آن هم نبود null
    getImage(variety) {
      if (variety.images != "") {
        return variety.images[0].url;
      }
      if (variety.product.images != "") {
        return variety.product.images[0].url;
      }
      return null;
    },

    // کم کردن تعداد (دکمه در template وقتی تعداد 1 است غیرفعال می‌شود)
    decrement(variety) {
      if (variety.quantity === 0) {
        return;
      }
      variety.quantity--;
      this.checkCoupon();
    },
    increment(variety) {
      variety.quantity++;
      this.checkCoupon();
    },

    handleDiscountChange(value) {
      this.discountAmount = value !== "" ? +value.replace(/\D/g, "") : "";
    },

    // حذف یک ردیف از لیست فروش یا مرجوعی
    deleteItem(variety, mode) {
      this[mode] = this[mode].filter((v) => {
        return v.id !== variety.id;
      });

      this.checkCoupon();
      // اگر هیچ فروشی نمانده، کیف پول صفر شود
      if (!this.varieties.length) {
        this.walletB = 0;
      }
      // اگر هیچ مرجوعی نمانده، فاکتورهای مرجع پاک شوند
      // if (!this.refund_varieties.length) {
      //   this.orderItems = [];
      // }
    },

    // جستجوی مشتری بعد از وارد شدن ۱۱ رقم موبایل
    async requestCustomer(mobile) {
      if (mobile.length !== 11) return;
      try {
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/mini_orders/customer-search",
          {
            params: {
              mobile,
            },
          },
        );
        this.disabled = false;
        const data = response.data.data;
        // اگر مشتری جدید باشد customer وجود ندارد
        this.firstName = data.customer?.first_name || "";
        this.lastName = data.customer?.last_name || "";
        data.from_wallet_amount = data.from_wallet_amount || 0;
        this.customerInfo = data;
        this.bonCount = 0;
        this.bonValue = 0;
        // اگر قبلاً کالایی در لیست فروش است، کیف پول پیش‌فرض = کل موجودی
        this.walletB = this.varieties.length
          ? this.customerInfo?.customer?.wallet?.balance || 0
          : 0;

        this.productSku = "";
      } catch (e) {
        // ⚠️ در حالت خطا this.disabled روی true می‌ماند و اینپوت‌ها قفل می‌شوند
        // باید disabled=false در finally قرار بگیرد
        this.$root.notify(e);
      }
    },

    // لغو مشتری و ریست کردن همه چیز مربوط به او

    clearCustomer() {
      this.customerInfo = null;
      this.walletB = 0;
      this.customerMobile = "";
      this.bonCount = 0;
      this.bonValue = 0;
      // this.orderItems = [];
      this.refund_varieties.forEach((v) => {
        v.orderNumber = "";
        v.orderError = "";
        v.selectedOrder = null;
        v.selectedOrderItem = null;
      });
    },
    // ثبت نهایی سفارش
    async submit() {
      if (!this.validate()) {
        return;
      }
      // بن مصرفی را به سقف مجاز برسان
      const maxBonCount = this.maxBonCount;

      if (this.bonCount > maxBonCount) {
        this.bonCount = maxBonCount;
        this.bonValue =
          maxBonCount * (Number(this.customerInfo?.bon_value?.value) || 0);
      }

      // اگر مرجوعی نداریم و مجموع پرداخت‌ها بیشتر از فاکتور است → خطا
      if (!this.refund_varieties.length && this.netTotal < 0) {
        this.$root.notify(
          "مجموع مبالغ پرداختی بیشتر از مبلغ قابل پرداخت است.",
          "warning",
        );
        return;
      }

      // مبلغ فاکتور «قبل از کسر کیف پول» (بعد از مرجوعی، تخفیف، کارت، نقد)
      const totalBeforeWallet = (() => {
        const totalRefundAmount = this.refund_varieties.reduce(
          (sum, item) => sum + this.getRefundUnitAmount(item) * item.quantity,
          0,
        );
        let totalAmount = this.total - totalRefundAmount;
        totalAmount -= this.varieties.reduce(
          (total, item) => total + this.getTotalDiscount(item) * item.quantity,
          0,
        );
        if (this.discountAmount > 0) totalAmount -= this.discountAmount;
        if (this.cardByCard_amount > 0) totalAmount -= this.cardByCard_amount;
        if (this.cash_amount > 0) totalAmount -= this.cash_amount;

        return totalAmount;
      })();

      // کیف پول نباید از باقی‌ماندهٔ فاکتور بیشتر باشد
      // ⚠️ بدون این چک، وقتی کارت/نقد کل مبلغ را پوشش دهد ولی walletB پر باشد، کیف پول اضافی کسر می‌شد
      if (
        this.walletB > 0 &&
        this.walletB > totalBeforeWallet &&
        !this.refund_varieties.length
      ) {
        this.$root.notify(
          "مبلغ کیف پول از قیمت فاکتور بیشتر میباشد.",
          "warning",
        );
        return;
      }

      // ساخت بدنهٔ درخواست
      let fd = new FormData();
      if (this.created_at) {
        fd.append("created_at", this.created_at);
      }
      fd.append(
        "cardByCard_amount",
        this.cardByCard_amount ? this.cardByCard_amount : 0,
      );

      fd.append("mobile", this.customerMobile);
      fd.append("creatorable_id", this.admin.id);
      fd.append("first_name", this.firstName);
      fd.append("last_name", this.lastName);
      fd.append("bon_value", this.bonValue);
      fd.append("cash_amount", this.cash_amount ? this.cash_amount : 0);
      fd.append(
        "discount_amount",
        Number(this.discountAmount) +
          Number(this.coupenPrice ? this.coupenPrice : 0),
      );
      fd.append("description", this.description);

      // اگر لیست فروش خالی است (فقط مرجوعی)، کیف پول 0 فرستاده می‌شود
      const walletToSend = this.varieties.length
        ? Number(this.walletB) || 0
        : 0;
      fd.append("from_wallet_amount", walletToSend);

      if (this.isOpen == true) {
        fd.append("is_open", 1);
      } else {
        fd.append("is_open", this.isOpen);
      }
      if (this.coupen) fd.append("coupon_code", this.coupen);
      fd.append("sendCouponIsActive", this.sendCoupenStatus ? 1 : 0);

      // آیتم‌های فروش
      this.varieties.forEach((item, index) => {
        fd.append(
          `varieties[${index}][seller_id]`,
          this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null,
        );
        fd.append(`varieties[${index}][id]`, item.id);
        fd.append(`varieties[${index}][quantity]`, item.quantity);

        const productDiscount = Number(item.final_price?.discount_price) || 0;
        const clubDiscount = this.getClubDiscountPrice(item);
        const cashierDiscount = Number(item.cashier_discount) || 0;
        const totalItemDiscount =
          productDiscount + clubDiscount + cashierDiscount;
        fd.append(
          `varieties[${index}][amount]`,
          item.price - totalItemDiscount,
        );
        fd.append(`varieties[${index}][discount_amount]`, totalItemDiscount);
        fd.append(`varieties[${index}][cashier_discount]`, cashierDiscount);
        fd.append(`varieties[${index}][club_discount_amount]`, clubDiscount);

        // قیمت اصلی فقط وقتی تخفیفی هست فرستاده می‌شود
        if (totalItemDiscount > 0) {
          fd.append(`varieties[${index}][real_amount]`, item.price);
        }
      });

      // آیتم‌های مرجوعی
      this.refund_varieties.forEach((item, index) => {
        const sel = item.selectedOrderItem; // آیتم فاکتور مرجع (اگر انتخاب شده)
        fd.append(
          `refund_varieties[${index}][seller_id]`,
          this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null,
        );
        fd.append(`refund_varieties[${index}][id]`, item.id);
        fd.append(`refund_varieties[${index}][quantity]`, item.quantity);

        if (sel && sel.id) {
          // حالت ۱: مرجوعی با فاکتور مرجع → مبالغ از فاکتور قبلی خوانده می‌شود
          fd.append(
            `refund_varieties[${index}][refrence_mini_order_item_id]`,
            sel.id,
          );
          fd.append(`refund_varieties[${index}][gift_bon]`, sel.gift_bon || 0);
          fd.append(
            `refund_varieties[${index}][gift_score]`,
            sel.gift_score || 0,
          );
          fd.append(
            `refund_varieties[${index}][spend_bon]`,
            this.getSpendBonPerItem(item),
          );
          fd.append(`refund_varieties[${index}][amount]`, sel.amount);
          fd.append(`refund_varieties[${index}][real_amount]`, sel.amount);
          fd.append(
            `refund_varieties[${index}][discount_amount]`,
            (Number(sel.discount_amount) || 0) +
              (Number(sel.club_discount) || 0),
          );
          fd.append(
            `refund_varieties[${index}][cashier_discount]`,
            sel.cashier_discount || 0,
          );
          fd.append(
            `refund_varieties[${index}][club_discount]`,
            Number(sel.club_discount),
          );
        } else {
          // حالت ۲: مرجوعی بدون فاکتور مرجع → قیمت منهای تخفیف محصول
          const productDiscount = Number(item.final_price?.discount_price) || 0;
          const clubDiscount = this.getClubDiscountPrice(item);
          const cashierDiscount = Number(item.cashier_discount) || 0;
          const totalItemDiscount =
            productDiscount + clubDiscount + cashierDiscount;
          fd.append(
            `refund_varieties[${index}][amount]`,
            item.price - totalItemDiscount,
          );
          fd.append(
            `refund_varieties[${index}][discount_amount]`,
            totalItemDiscount,
          );
          fd.append(
            `refund_varieties[${index}][cashier_discount]`,
            cashierDiscount,
          );
          fd.append(
            `refund_varieties[${index}][club_discount_amount]`,
            clubDiscount,
          );
          if (totalItemDiscount > 0) {
            fd.append(`refund_varieties[${index}][real_amount]`, item.price);
          }
        }
      });

      try {
        this.reqDiasableStyle = false; // دکمه ثبت غیرفعال
        this.disabled = true;
        const response = await this.$axios.post("admin/mini_orders", fd);

        const miniOrder = response.data.data.mini_order;
        this.$root.notify(response.data.message, "success");
        // رفتن به صفحهٔ فاکتور با پرینت خودکار
        this.$router.push(`/admin/shop/orders/${miniOrder.id}?print=1`);
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.reqDiasableStyle = true;
      }
    },

    // اعتبارسنجی اولیه: حداقل یک کالا (فروش یا مرجوعی) باید وجود داشته باشد
    validate() {
      // ⚠️ باگ: شرط دوم `!this.refund_varieties && !this.refund_varieties.length` همیشه false است
      // (آرایه همیشه truthy است) پس این اعتبارسنجی هیچ‌وقت خطا نمی‌دهد.
      // درست: !this.varieties.length && !this.refund_varieties.length
      if (
        (!this.varieties || !this.varieties.length) &&
        !this.refund_varieties &&
        !this.refund_varieties.length
      ) {
        this.$root.warningNotify("حداقل انتخاب یک تنوع الزامی است");
        return false;
      }
      return true;
    },
  },
  watch: {
    discountAmount(newValue) {
      this.checkCoupon();
    },

    // هر تغییری در مرجوعی‌ها: وضعیت hasSelectedItem را به‌روز کن (نمایش ستون بن مصرفی)
    refund_varieties: {
      handler() {
        this.hasSelectedItem = this.refund_varieties.some(
          (v) => v.selectedOrderItem,
        );
      },
      deep: true,
    },
  },
  created() {
    this.getSellers();
    this.getAdmin();
  },
};
</script>

<style scoped>
.table-responsive {
  height: auto;
}

.reqDiasableStyle {
  pointer-events: none;
  opacity: 0.5;
}

.order-product-img {
  max-width: 50px;
  margin: auto;
}

.table-title {
  font-weight: bold;
}
</style>
<style>
.card.little.info {
  background: linear-gradient(30deg, #d2e8ff 0%, #d5e6fc 35%, #eaf5ff 100%);
}

.card.little.online {
  background: linear-gradient(30deg, #c8ffc8 0%, #c8ffc8 35%, #e0ffe0 100%);
}

.card.little.physical {
  background: linear-gradient(30deg, #ffffe3 0%, #ffffbc 35%, #ffffc5 100%);
}

.card.little .card-header {
  font-weight: bold;
}

form#coupenCode input[type="submit"] {
  background-color: #1d99ff;
  color: white;
}

form#coupenCode input {
  padding: 4px 8px;
  border: 2px solid #1d99ff;
}

.disableCoupen {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

button#sendCoupen {
  display: flex;
  align-items: center;
  gap: 8px;
}

button#sendCoupen input {
  transform: scale(1.5);
}

.btnprimary {
  color: #fff !important;
  background-color: #0075ff;
  border-color: #3366ff;
}

.btnprimary:hover {
  background-color: #0256b8;
}

.btnprimary:hover input[type="checkbox"] {
  accent-color: #0256b8;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}

div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(6, 2fr);
  gap: 12px;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}

div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(10, 4fr);
  gap: 8px;
}

.mt-3.admin-order.table-responsive.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store {
  overflow: visible;
}

div#selectSellerModal {
  position: fixed;
  inset: 0;
  background: #11221194;
  z-index: 10000;
}

div#selectSellerModalContainer {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}
.customer-info-box {
  background: #f8f9fb;
  border-radius: 14px;
  padding: 16px;
}

.info-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid #eef0f3;
  transition: box-shadow 0.2s, transform 0.2s;
}

.info-card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.info-card-icon {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
}

.wallet-icon {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}
.purchase-icon {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}
.level-icon {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}
.bon-icon {
  background: linear-gradient(135deg, #ec4899, #db2777);
}
.score-icon {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
}

.info-card-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.info-card-label {
  font-size: 12px;
  color: #8a8f98;
}

.info-card-value {
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
}

.info-card-unit {
  font-weight: 400;
  font-size: 11px;
  color: #6b7280;
}
</style>
